import Menu from "../../components/menu"
import useAuth from "../../hooks/useAuth"

import { useQuery, keepPreviousData } from "@tanstack/react-query"
import { authApi } from "../../services/api/api"

import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import moment from "moment"
import MiniBook from "../../components/miniBook"
import { useLocation } from "react-router-dom"


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';


import { useEffect, useState } from "react"
import ActualBook from "../../components/skeletons/actualBook"
import SkeletonMiniBook from "../../components/skeletons/miniBook"
import TextEditor from "../../components/textEditor"
import { FastAverageColor } from "fast-average-color"
import { Book } from "lucide-react"
import confetti from 'canvas-confetti';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export default function MeusLivros() {

    const { user, theme } = useAuth()

    const api = authApi()

    const att = useLocation()

    const [attBooks, setAttBooks] = useState(null)

    const themeMui = useTheme();

    const isMobile = useMediaQuery(themeMui.breakpoints.down('sm'));

    const { data, isPending } = useQuery(
        {
            queryKey: ['myBooks', att.state, user, attBooks],
            queryFn: () => api.myBooks(user?.id),
            // placeholderData:keepPreviousData, 
            // staleTime: 5 * 60 * 1000
        }
    )

    const openPost = moment().isBetween(user?.start, user?.end)

    const start = moment(data?.[0]?.start).format('DD/MM/YYYY')

    const end = moment(data?.[0]?.end).format('DD/MM/YYYY')

    const dataAtual = moment().format('DD/MM/YYYY')
    const [text, setText] = useState('');
    const dataAtual1 = moment().format('YYYY/MM/DD')
    const [selectedReview, setSelectedReview] = useState<any>(null);

    //diferença entre a data inicial e a data final em dias
    const diff = moment(end, "DD/MM/YYYY").diff(moment(dataAtual, "DD/MM/YYYY"));
    //dias restantes
    const dias = moment.duration(diff).asDays();

    const diasPassados = 30 - dias

    const taxa = 100 / 30

    //porcentagem da barra
    const percent = diasPassados * taxa

    const [open, setOpen] = useState(false);

    const [id, setId] = useState();

    const handleClickOpen = (item: any) => {
        console.log(item)
        setSelectedReview({
            id: item.id,               // ID do empréstimo
            title: item.books?.title,   // Título do livro
            user: item.user_id,          // ID do usuário logado
            book: item.book_id,      // ID do livro
        });

        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };



    async function handleSetPost() {
        if (!text || text.trim() === "") {
            toast.error('O conteúdo da review não pode estar vazio.', { theme: 'dark' });
            return;
        }
        const textWithoutTags = text.replace(/<[^>]*>?/gm, '');
        toast.info('Carregando.', { theme: 'dark', toastId: 'loadPost' })
        const dados = {
            ...selectedReview,
            text: textWithoutTags
        };

        const response = await api.setPost(dados)
        triggerConfetti();
        if (response === 200) {
            toast.success('Post Criado com sucesso!.', { theme: 'dark', toastId: 'successPost' })
            toast.dismiss('loadPost')
            setText('')
            handleClose()
        } else {
            toast.error('Houve algum erro, tente novamente mais tarde.', { theme: 'dark', toastId: 'errorPost' })
        }
    }
    const triggerConfetti = () => {
        const duration = 3 * 1000;
        const animationEnd = Date.now() + duration;
        const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 };

        const randomInRange = (min: number, max: number) => Math.random() * (max - min) + min;

        const interval: any = setInterval(function () {
            const timeLeft = animationEnd - Date.now();

            if (timeLeft <= 0) {
                return clearInterval(interval);
            }

            const particleCount = 50 * (timeLeft / duration);

            // Solta confetes de dois pontos laterais
            confetti({
                ...defaults,
                particleCount,
                origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
                colors: ['#195AB4', '#ffffff', '#60A5FA'] // Cores azuladas do seu tema
            });
            confetti({
                ...defaults,
                particleCount,
                origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
                colors: ['#195AB4', '#ffffff', '#60A5FA']
            });
        }, 250);
    };
    async function handleDismiss(id: number) {
        toast.loading('Carregando.', { theme: 'dark', toastId: 'dismissLoad' })
        const response = await api.dismissBooksUser(id)
        console.log(response)
        if (response == 200) {
            toast.success('Livro entregue com sucesso.', { theme: 'dark', toastId: 'dismiss' })
            toast.dismiss('dismissLoad')
            setAttBooks((old) => !old)
            return
        }
        toast.dismiss('dismissLoad')
        toast.error('Não foi possivel entregar o livro.', { theme: 'dark', toastId: 'dismiss-error' })

    }

    const [gradientColor, setGradientColor] = useState('transparent');

    useEffect(() => {
        const imageUrl = data?.[0]?.books?.img;
        const fac = new FastAverageColor();

        if (imageUrl) {
            fac.getColorAsync(imageUrl)
                .then(color => {
                    const mainColor = color.hex;
                    // Escurecemos 40% para o fundo do gradiente
                    const darkColor = darkenHexColor(mainColor, -0.4);
                    setGradientColor(`linear-gradient(135deg, ${mainColor}, ${darkColor})`);
                })
                .catch(() => setGradientColor('#103E89')); // Cor padrão de fallback
        }
    }, [data?.[0]?.books?.img]);

    // Função auxiliar de escurecimento (mesma usada no MiniBook)
    function darkenHexColor(hex: string, lum: number) {
        hex = String(hex).replace(/[^0-9a-f]/gi, '');
        if (hex.length < 6) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        let rgb = "#", c, i;
        for (i = 0; i < 3; i++) {
            c = parseInt(hex.substr(i * 2, 2), 16);
            c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
            rgb += ("00" + c).substr(c.length);
        }
        return rgb;
    }

    // console.log(data)
    return (
        <div className={`main w-screen  bg-gray-100 ${theme} overflow-x-hidden`}>
            <Menu />
            <div className="content w-screen min-h-screen flex justify-cente dark:bg-[#061c3f] bg-gray-100">
                <div className="w-full flex justify-center items-center p-8  ">
                    <div className="w-full flex justify-center items-center">
                        <div className="w-full max-w-[1770px]">
                            <div className="w-full">
                                <div className="flex flex-col gap-1">
                                    {/* Título com fonte levemente mais fina e espaçada */}
                                    <h4 className="text-slate-400 dark:text-slate-500 text-[10px] font-bold uppercase tracking-[0.3em]">
                                        Sua Estante
                                    </h4>
                                    <h2 className="text-xl font-bold text-slate-800 dark:text-white tracking-tight">
                                        Último Livro Reservado
                                    </h2>
                                    <div className="w-full h-[1px] bg-gray-200 dark:bg-white/10 mt-4"></div>

                                </div>


                                <div className="w-full flex justify-center my-8 px-4">
                                    {data?.[0] ? (
                                        <div className="flex flex-col md:flex-row w-full max-w-3xl bg-white dark:bg-[#2d3d5780] rounded-[24px] shadow-2xl overflow-hidden border border-gray-100 dark:border-slate-800 transition-all duration-300">

                                            {/* Lado Esquerdo: Capa */}
                                            <div className="relative p-6 flex flex-col items-center justify-center md:w-64 lg:border-r lg:border-dashed border-gray-200 dark:border-slate-200" style={{ background: gradientColor }}>
                                                <img
                                                    src={data?.[0]?.books?.img ?? ''}
                                                    alt="Capa"
                                                    className="w-32 h-48 object-cover rounded-lg shadow-[5px_15px_30px_rgba(0,0,0,0.3)] transform -rotate-1"
                                                />

                                                {/* Badge de Dias (Só aparece se NÃO foi entregue) */}
                                                {data?.[0]?.status !== 'Entregue' && (
                                                    <div className="mt-4 px-4 py-1 bg-orange-500 text-white rounded-full text-[11px] font-black uppercase tracking-widest shadow-lg shadow-orange-500/30">
                                                        {dias} dias restantes
                                                    </div>
                                                )}
                                            </div>

                                            {/* Lado Direito: Informações */}
                                            <div className="flex-1 p-8 flex flex-col justify-between">
                                                <div>
                                                    <div className="flex justify-between flex-col md:flex-row items-start gap-4 mb-6">
                                                        <div className="md:max-w-[70%] sm:max-w-full lg:max-w-none">
                                                            <h2 className="md:text-xl lg:text-2xl font-black text-slate-800 dark:text-white capitalize leading-none mb-2 text-sm">
                                                                {data?.[0]?.books?.title}
                                                            </h2>
                                                            <p className="text-sm font-bold text-gray-500 dark:text-gray-400 tracking-wide capitalize">
                                                                {data?.[0]?.books?.autor}
                                                            </p>
                                                        </div>

                                                        {/* <div className={`px-4 py-1.5 rounded-lg text-[10px] font-bold uppercase tracking-widest border ${data?.[0]?.status === 'Entregue'
                                                            ? 'bg-emerald-50 text-emerald-600 border-emerald-200'
                                                            : 'bg-amber-50 text-amber-600 border-amber-200 animate-pulse'
                                                            }`}>
                                                            {data?.[0]?.status}
                                                        </div> */}
                                                    </div>

                                                    {/* Grid de Datas - REESTRUTURADO */}
                                                    <div className="grid grid-cols-2 sm:grid-cols-2 gap-6 py-6 border-t border-gray-100 dark:border-slate-500 justify-center text-center">
                                                        {/* Sempre mostra quando foi retirado */}
                                                        <div className="flex flex-col gap-1">
                                                            <span className="text-[10px] text-gray-400 font-bold uppercase tracking-[0.1em]">Retirada em</span>
                                                            <span className="text-sm font-bold text-slate-700 dark:text-slate-200">{start}</span>
                                                        </div>

                                                        {/* Lógica Condicional para a Segunda Data */}
                                                        {data?.[0]?.status === 'Entregue' ? (
                                                            <div className="flex flex-col gap-1">
                                                                <span className="text-[10px] text-emerald-500 font-bold uppercase tracking-[0.1em]">Entregue em</span>
                                                                <span className="text-sm font-bold text-emerald-600">{end}</span>
                                                            </div>
                                                        ) : (
                                                            <div className="flex flex-col gap-1">
                                                                <span className="text-[10px] text-gray-400 font-bold uppercase tracking-[0.1em]">Devolução</span>
                                                                <span className={`text-sm font-bold ${
                                                                    // Verifica se a data existe e se é anterior à data atual
                                                                    data?.[0]?.finaly && moment(data[0].finaly).isBefore(moment())
                                                                        ? 'text-red-600'
                                                                        : 'text-slate-700 dark:text-slate-200'
                                                                    }`}>
                                                                    {end}
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Botões de Ação */}
                                                <div className="flex flex-wrap gap-3 mt-4">

                                                    {data?.[0]?.status !== 'Entregue' && (
                                                        <>
                                                            {openPost && (
                                                                <button
                                                                    onClick={() => handleClickOpen(data[0])}
                                                                    className="flex-1 min-w-[120px] py-3.5 px-4 bg-blue3 hover:bg-blue4 text-white font-bold text-[11px] uppercase tracking-widest rounded-xl transition-all active:scale-95"
                                                                >
                                                                    Publicar Review
                                                                </button>
                                                            )}
                                                            <button
                                                                onClick={() => handleDismiss(data?.[0]?.id)}
                                                                className="flex-1 min-w-[120px] py-3.5 px-4 bg-slate-100 dark:bg-white/10 text-slate-600 dark:text-white font-black text-[11px] uppercase tracking-widest rounded-xl hover:bg-slate-200 dark:hover:bg-slate-700 transition-all active:scale-95"
                                                            >
                                                                Devolver Agora
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                            </div>

                                        </div>

                                    ) : isPending ? (

                                        <ActualBook />


                                    ) : (
                                        <div className="p-12 bg-gray-50 dark:bg-slate-900/50 rounded-[32px] border-2 border-dashed border-gray-200 dark:border-slate-800 text-center">
                                            <h2 className="text-gray-400 font-bold text-lg">Nenhuma reserva ativa</h2>
                                        </div>
                                    )}

                                </div>

                                <div className="flex flex-col gap-1">
                                    {/* Label sutil em cima para contexto */}
                                    <span className="text-[10px] text-slate-400 dark:text-slate-500 font-bold uppercase tracking-[0.3em]">
                                        Registros
                                    </span>
                                    {/* Título Principal */}
                                    <h2 className="text-xl font-bold text-slate-800 dark:text-white tracking-tight">
                                        Histórico de Leituras
                                    </h2>
                                    <div className="w-full h-[1px] bg-gray-200 dark:bg-white/10 mt-4"></div>

                                </div>



                                <div className="my-8 w-full mx-auto px-4">
                                    {data?.length > 0 ? (
                                        /* Grid responsivo: 1 col em mobile, 2 em tablets, até 4 em telas grandes */
                                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6 justify-items-center">
                                            {data.map((item: any) => (
                                                <MiniBook
                                                    handleDismiss={handleDismiss}
                                                    openPost={openPost}
                                                    key={item.id}
                                                    item={item}
                                                    handleClickOpen={handleClickOpen}
                                                />
                                            ))}
                                        </div>
                                    ) : isPending ? (
                                        /* Garante que o Skeleton também siga o mesmo grid */
                                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6 justify-items-center">
                                            <SkeletonMiniBook />
                                        </div>
                                    ) : (
                                        <div className="flex flex-col items-center justify-center p-12 border-2 border-dashed border-gray-200 dark:border-slate-800 rounded-[30px]">
                                            <h1 className="text-gray-400 font-bold text-lg">Nenhum livro reservado</h1>
                                            <p className="text-gray-400 text-sm">Sua estante de reservas aparecerá aqui.</p>
                                        </div>

                                    )}

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullScreen={isMobile}

                PaperProps={{
                    style: {
                        borderRadius: isMobile ? 0 : '24px',
                        backgroundImage: 'none',
                        maxWidth: '800px', // Um pouco mais largo para o editor de texto
                        width: '100%',
                        overflow: 'hidden'
                    },
                }}
            >
                {/* Header com Identidade Visual Forte */}
                <div className="bg-gradient-to-r from-blue1 to-blue3 px-8 py-6 border-b border-white/10 shadow-lg">
                    <div className="flex items-center gap-4">
                        <div className="bg-white/10 p-3 rounded-2xl backdrop-blur-md border border-white/20">
                            <Book className="text-white" size={17} />
                        </div>
                        <div>
                            <span className="text-[10px] uppercase font-black tracking-[0.4em] text-blue-100/60 block mb-1">
                                Nova Publicação
                            </span>
                            <h3 className="text-2xl font-bold text-white leading-tight">
                                Publicar Reflexão
                            </h3>
                        </div>
                    </div>
                </div>

                <DialogContent className="pt-8 pb-4">
                    <div className="flex flex-col gap-4">
                        {/* Label de Instrução Sutil */}
                        <div className="flex items-center gap-2 mb-1">
                            <label className="text-[11px] uppercase font-bold tracking-widest text-slate-400 dark:text-blue-300/50">
                                O que você achou desta leitura?
                            </label>
                        </div>

                        {/* Container do Editor com efeito de profundidade */}
                        <div className="rounded-3xl border-2 border-gray-100 dark:border-white/5 overflow-hidden bg-white shadow-inner focus-within:border-blue-500/40 transition-all min-h-[300px]">
                            <TextEditor text={text} setText={setText} />
                        </div>

                        <p className="text-[11px] text-slate-400 italic px-2">
                            Dica: Use as ferramentas de formatação para destacar os pontos mais importantes.
                        </p>
                    </div>
                </DialogContent>

                <DialogActions className="p-8 pt-2 flex gap-4 border-t border-gray-100">
                    <div className="flex w-full my-2">
                        {/* Botão Cancelar Minimalista */}
                        <button
                            onClick={handleClose}
                            className="flex-1 h-14 text-xs font-bold text-gray-400 hover:text-gray-600 dark:hover:text-white transition-colors tracking-widest uppercase"
                        >
                            Descartar
                        </button>

                        {/* Botão Publicar Robusto */}
                        <button
                            onClick={handleSetPost}
                            className="flex-[2] h-14 bg-blue3 hover:bg-blue4 text-white text-xs font-bold rounded-2xl shadow-xl shadow-blue-500/30 transition-all active:scale-95 uppercase tracking-[0.2em] flex items-center justify-center gap-3"
                        >
                            Publicar Agora
                        </button>
                    </div>
                </DialogActions>
            </Dialog>
            <ToastContainer />
            {/* <span></span> */}
            {/* <Footer/> */}
        </div>
    )
}